import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

// 歷史紀錄大小限制，防止無限增長導致記憶體洩漏
const MAX_HISTORY_SIZE = 50

export const useSideMenuStore = defineStore('sideMenu', () => {
  // State
  const menu = ref(null)
  const menuItemStack = ref([])
  const historyStack = ref([])
  const previousMenuItemStack = ref([])
  const defaultMenuItemStack = ref([])
  const loading = ref(false)
  const error = ref(null)
  const lastUpdateTime = ref(null)

  // Getters
  const getMenu = computed(() => menu.value)
  const getMenuItemStack = computed(() => menuItemStack.value)
  const getHistoryStack = computed(() => historyStack.value)
  const getDefaultMenuItemStack = computed(() => defaultMenuItemStack.value)
  const getLoading = computed(() => loading.value)
  const getError = computed(() => error.value)
  const getLastUpdateTime = computed(() => lastUpdateTime.value)

  const getCurrentItem = computed(() => {
    return menuItemStack.value.length > 0 ? menuItemStack.value[menuItemStack.value.length - 1] : null
  })

  const getCurrentPath = computed(() => {
    return menuItemStack.value.map((item) => ({
      id: item.categoryId,
      name: item.name,
      level: item.level,
    }))
  })

  const canGoBack = computed(() => {
    return historyStack.value.length > 0
  })

  // Actions
  function setMenu(data) {
    menu.value = data
  }

  function setMenuItemStack(data) {
    menuItemStack.value = data
  }

  function setPreviousMenuItemStack(data) {
    previousMenuItemStack.value = data
  }

  function setHistoryStack(data) {
    historyStack.value = data
  }

  function setDefaultMenuItemStack(data) {
    defaultMenuItemStack.value = data
  }

  function setLoading(data) {
    loading.value = data
  }

  function setError(data) {
    error.value = data
  }

  function setLastUpdateTime(data) {
    lastUpdateTime.value = data
  }

  function pushHistoryItem(data) {
    if (!data) return

    const isDuplicate = historyStack.value.length > 0 && historyStack.value[historyStack.value.length - 1].categoryId === data.categoryId

    if (!isDuplicate) {
      historyStack.value = [...historyStack.value, data]
      // 超過上限時移除最舊的紀錄
      if (historyStack.value.length > MAX_HISTORY_SIZE) {
        historyStack.value = historyStack.value.slice(-MAX_HISTORY_SIZE)
      }
    }
  }

  function popHistoryItem() {
    if (historyStack.value.length > 0) {
      historyStack.value = historyStack.value.slice(0, -1)
    }
  }

  function resetToDefault() {
    menuItemStack.value = []
    historyStack.value = []
  }

  return {
    // State
    menu,
    menuItemStack,
    previousMenuItemStack,
    historyStack,
    defaultMenuItemStack,
    loading,
    error,
    lastUpdateTime,

    // Getters
    getMenu,
    getMenuItemStack,
    getHistoryStack,
    getDefaultMenuItemStack,
    getLoading,
    getError,
    getLastUpdateTime,
    getCurrentItem,
    getCurrentPath,
    canGoBack,

    // Actions
    setMenu,
    setMenuItemStack,
    setPreviousMenuItemStack,
    setHistoryStack,
    setDefaultMenuItemStack,
    setLoading,
    setError,
    setLastUpdateTime,
    pushHistoryItem,
    popHistoryItem,
    resetToDefault,
  }
})
